import React, { useEffect, useState } from "react";
import { BsTrash } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ScreenLoader from "../../../../components/Loader/ScreenLoader";
import http, { URL_S3 } from "../../../../config/BaseUrl";
import useTimeFormate from "../../../../hook/useTimeFormat";
import DeleteModal from "../../components/Modal/DeleteModal";
import {
  setDuplicateEvent,
  setLoadedEvent,
  setLoadingContent,
  setLoadingEvent,
} from "../../liveEvent/slice/liveEventSlice";
import { eventDraftToContinue } from "../slice/createEventSlice";
const DraftProduct = () => {
  const { formateLocalTime } = useTimeFormate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();

  const { loadedEvent, loadingEvent, loadingContent, duplicateEvent } =
    useSelector((state) => state.liveEvent);

  const fetchDraftProduct = async () => {
    try {
      setIsLoading(true);
      await http.get("draft-event").then((res) => {
        if (res) {
          setData(res.data.draft_product);
        }
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDraftProduct();
  }, []);

  const continueToPage = (id) => {
    http
      .get("continue/draft-event", { params: { eventId: id } })
      .then((res) => {
        let events = res.data.event;

        let event_info = {
          event_name: events.event_name,
          event_details: events.event_details,
          event_venue_name: events.venue_name,
          event_time_zone: events.time_zone,
          event_start_date: events.event_start_date,
          event_end_date: events.event_end_date,
          life_time: events.life_time,
          fileURL: "",
        };

        let feature = {
          still_photo: events.feature
            ? events.feature.still_photo[0].lock == "enable"
              ? true
              : false
            : false,
          three_in_one: events.feature
            ? events.feature.three_in_one[0].lock == "enable"
              ? true
              : false
            : false,
          video: events.feature
            ? events.feature.video[0].lock == "enable"
              ? true
              : false
            : false,
          boomerang: events.feature
            ? events.feature.boomerang[0].lock == "enable"
              ? true
              : false
            : false,
          gallery: events.feature
            ? events.feature.gallery[0].lock == "enable"
              ? true
              : false
            : false,
          sharing: events.feature
            ? events.feature.sharing[0].lock == "enable"
              ? true
              : false
            : false,
          data_capture: events.feature
            ? events.feature.data_capture[0].lock == "enable"
              ? true
              : false
            : false,
        };

        let event_option = {
          social_media: events.event_option
            ? events.event_option.social_media > 0
              ? true
              : false
            : false,
          gif: events.event_option
            ? events.event_option.gif > 0
              ? true
              : false
            : false,
          brust_gif: events.event_option
            ? events.event_option.brust_gif > 0
              ? true
              : false
            : false,
          email: events.event_option
            ? events.event_option.email > 0
              ? true
              : false
            : false,
          text_messaging: events.event_option
            ? events.event_option.text_messaging > 0
              ? true
              : false
            : false,
          digital_props: events.event_option
            ? events.event_option.digital_props > 0
              ? true
              : false
            : false,
          water_mark: events.event_option
            ? events.event_option.water_mark > 0
              ? true
              : false
            : false,
          microsite: events.event_option
            ? events.event_option.microsite > 0
              ? true
              : false
            : false,
          frame_option: events.event_option
            ? events.event_option.frame > 0
              ? true
              : false
            : false,
          video_frame_option: events.event_option
            ? events.event_option.video_frame > 0
              ? true
              : false
            : false,
          boomerang_frame_option: events.event_option
            ? events.event_option.boomerang_frame > 0
              ? true
              : false
            : false,
          filters: events.event_option
            ? events.event_option.filters > 0
              ? true
              : false
            : false,
          adminPassword: events.event_option
            ? events.event_option.admin_password
            : "",
        };

        let social = {
          instagram: events.social ? events.social.instagram : false,
          client_facebook: events.social
            ? events.social.client_facebook
            : false,
          email_message: events.social ? events.social.email_message : "",
        };

        // 3 in 1 & 3 in 1 fast
        let eventGifs = [];
        events.gif_gallery.length > 0 &&
          events.gif_gallery.forEach((item) => {
            eventGifs.push({ id: item.gif_id, image: item.photo });
          });
        let event_gif = eventGifs;

        let eventBrustGifs = [];
        events.brust_gif_gallery.length > 0 &&
          events.brust_gif_gallery.forEach((item) => {
            eventBrustGifs.push({ id: item.brust_gif_id, image: item.photo });
          });
        let brust_gifs = eventBrustGifs;

        let email = {
          from_name: events.email_setting
            ? events.email_setting.form_name
            : null,
          reply_to: events.email_setting ? events.email_setting.reply_to : null,
          email_subject: events.email_setting
            ? events.email_setting.email_subject
            : null,
          send: events.email_setting ? events.email_setting.send : null,
          email_template: events.email_setting
            ? {
                id: events.email_setting.email_template_id,
                image: events.email_setting.email_template,
              }
            : null,
        };

        let sms_sharing = {
          text_message: events.text_message
            ? events.text_message.text_message
            : "",
          send: events.text_message ? events.text_message.send : "",
          country: events.text_message ? events.text_message.country : "",
          google_review_custom_message: events.text_message
            ? events.text_message.google_review_custom_message
            : "",
          google_review_link: events.text_message
            ? events.text_message.google_review_link
            : "",
          google_review_message_delay: events.text_message
            ? events.text_message.google_review_message_delay
            : "",
        };

        let WaterMark = {
          photo: events.WaterMark ? events.WaterMark.photo : "",
          align_x: events.WaterMark ? events.WaterMark.align_x : "",
          align_y: events.WaterMark ? events.WaterMark.align_y : "",
        };

        let digitalItems = [];

        if (events.digital_prop.length > 0) {
          events.digital_prop.forEach((item) => {
            digitalItems.push({ id: item.prop_id, image: item.photo_frame });
          });
        }

        let digital_prop = {
          digital_prop_frame: digitalItems,
        };

        let micro_site = {
          sms: events.microsite
            ? events.microsite.sms > 0
              ? true
              : false
            : false,
          email: events.microsite
            ? events.microsite.email > 0
              ? true
              : false
            : false,
          facebook: events.microsite
            ? events.microsite.facebook > 0
              ? true
              : false
            : false,
          instagram: events.microsite
            ? events.microsite.instagram > 0
              ? true
              : false
            : false,
          linked_in: events.microsite
            ? events.microsite.linked_in > 0
              ? true
              : false
            : false,
          twitter: events.microsite
            ? events.microsite.twitter > 0
              ? true
              : false
            : false,
          download: events.microsite
            ? events.microsite.download > 0
              ? true
              : false
            : false,
          gallery_button: events.microsite
            ? events.microsite.gallery_button > 0
              ? true
              : false
            : false,
          meta_title: events.microsite ? events.microsite.meta_title : "",
          gallery_password: events.microsite
            ? events.microsite.gallery_password
            : null,
          microSite_template: events.microsite
            ? events.microsite.micro_site_gallery
            : null,
        };

        let eventFrames = [];
        events.photo_frame.length > 0 &&
          events.photo_frame.forEach((item) => {
            eventFrames.push({ id: item.frame_id, image: item.photo_frame });
          });

        let photo_template_frame = eventFrames;

        let eventVideoFrames = [];
        events.event_video_frame.length > 0 &&
          events.event_video_frame.forEach((item) => {
            eventVideoFrames.push({ id: item.video_frame_id, image: item.photo_frame });
          });
        let video_template_frame = eventVideoFrames;

        let eventBoomerangFrames = [];
        events.event_boomerang_frame.length > 0 &&
          events.event_boomerang_frame.forEach((item) => {
            eventBoomerangFrames.push({ id: item.boomerang_frame_id, image: item.photo_frame });
          });
        let boomerang_template_frame = eventBoomerangFrames;

        let filterItems = [];
        events.filter.length > 0 &&
          events.filter.forEach((item) => {
            filterItems.push({
              id: item.color_filter_id,
              image: item.filter_photo,
            });
          });

        let filters = filterItems;

        dispatch(
          eventDraftToContinue({
            eventId: id,
            event_info,
            feature,
            event_option,
            social,
            event_gif,
            brust_gifs,
            email,
            sms_sharing,
            WaterMark,
            digital_prop,
            micro_site,
            photo_template_frame,
            video_template_frame,
            boomerang_template_frame,
            filters,
          })
        );

        if (events.filter.length > 0) {
          history.push("/event/filter");
        } else if (events.event_boomerang_frame.length > 0) {
          history.push("/event/boomerang-frame");
        } else if (events.event_video_frame.length > 0) {
          history.push("/event/video-frame");
        } else if (events.photo_frame.length > 0) {
          history.push("/event/frame");
        } else if (events.microsite) {
          history.push("/event/microsite");
        } else if (events.digital_prop.length > 0) {
          history.push("/event/digital-prop");
        } else if (events.email_setting) {
          history.push("/event/email");
        } else if (events.text_message) {
          history.push("/event/sms");
        } else if (events.gif_gallery.length > 0) {
          history.push("/event/gif");
        } else if (events.brust_gif_gallery.length > 0) {
          history.push("/event/brust-gif");
        }else if (events.social) {
          history.push("/event/social");
        } else if (events.WaterMark) {
          history.push("/event/custom-branding");
        } else if (events.event_option) {
          history.push("/event/options");
        } else if (events.feature) {
          history.push("/event/feature");
        } else if (events) {
          history.push("/event/feature");
        } else {
          history.push("/event/summary");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const duplicateEventAction = (item) => {
    const params = {
      uuid: item.uuid,
      event_id: item.id,
    };

    dispatch(setDuplicateEvent(params));
  };

  return (
    <>
      <div className="row">
        {!isLoading ? (
          data && data.length > 0 ? (
            data.map((res) => {
              return (
                <div className="col-md-6 col-lg-4 col-xl-4" key={res.id}>
                  <div
                    className="live__event__card"
                    style={{
                      backgroundImage: `url(${
                        URL_S3 + "image/event_info/" + res.event_info_image
                      })`,
                      backgroundSize: "cover",
                    }}
                  >
                    <div className="event-content">
                      <p className="mb-1 text-white event-name">
                        {res.event_name}
                      </p>
                      <p className="mb-0 text-white">@ {res.venue_name}</p>
                    </div>
                    <div className="event-time-and-action">
                      <div className="event-time">
                        <p className="mb-0">
                          From: {formateLocalTime(res.event_start_date)}
                        </p>
                        <p className="mb-0">
                          To: {formateLocalTime(res.event_end_date)}
                        </p>
                      </div>
                      <div className="event-action d-flex justify-content-end align-items-center">
                        <a
                          href="#"
                          onClick={duplicateEventAction.bind(this, res)}
                          className="event-action-btn"
                          data-toggle="modal"
                          data-target="#draft-modal-remove"
                          title="Remove"
                        >
                          <BsTrash />
                        </a>
                        <span
                          className="continue-draft"
                          onClick={continueToPage.bind(this, res.id)}
                        >
                          Continue{" "}
                          <i class="fadeIn animated bx bx-right-arrow-alt"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-12">
              <div className="empty-event">
                <div className="empty-event-content">
                  <h4 className="empty-event-title">No Events Found</h4>
                </div>
              </div>
            </div>
          )
        ) : (
          <div className="col-12">
            <div className="empty-event">
              <div className="empty-event-content">
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {loadingEvent && (
        <ScreenLoader loadingContent={loadingContent} loaded={loadedEvent} />
      )}

      <DeleteModal
        modalId={"draft-modal-remove"}
        selectedItem={duplicateEvent}
        setLoadedEvent={setLoadedEvent}
        setLoadingEvent={setLoadingEvent}
        setLoadingContent={setLoadingContent}
      />
    </>
  );
};

export default DraftProduct;
